"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

type SummaryItem = {
  title: string;
  body: string;
};

export function LandingProductSummary() {
  const t = useTranslations("landing");
  const ref = useScrollReveal<HTMLElement>({ animation: "fade-up" });
  const items = t.raw("productSummary.items") as SummaryItem[];

  return (
    <section className="py-20" ref={ref} aria-labelledby="product-summary-title">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-10 max-w-3xl">
          <span className="mb-4 inline-block rounded-full border border-landing-border bg-landing-card px-4 py-1.5 text-xs font-medium uppercase tracking-wide text-mint">
            {t("productSummary.label")}
          </span>
          <h2 id="product-summary-title" className="text-3xl font-bold tracking-tight text-ink sm:text-4xl">
            {t("productSummary.title")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-landing-muted">
            {t("productSummary.subtitle")}
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {items.map((item) => (
            <article
              key={item.title}
              className="rounded-2xl border border-landing-border bg-landing-card p-6"
            >
              <h3 className="text-sm font-semibold uppercase tracking-wide text-mint">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-landing-muted">
                {item.body}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs text-landing-muted">
          {t("productSummary.updated")}
        </p>
        <Link
          href="/blog/ai-carousel-generator"
          className="mt-6 inline-flex rounded-full border border-landing-border bg-landing-card px-5 py-2.5 text-sm font-semibold text-ink transition-colors hover:border-mint hover:text-mint"
        >
          {t("productSummary.guideCta")}
        </Link>
      </div>
    </section>
  );
}
